import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// Every theme's typefaces, bundled rather than fetched: VMS can run where
// the browser reaches nothing else. A browser downloads only those in use.
import '@fontsource-variable/geist'
import '@fontsource-variable/geist-mono'
import '@fontsource/ibm-plex-sans/400.css'
import '@fontsource/ibm-plex-sans/500.css'
import '@fontsource/ibm-plex-sans/600.css'
import '@fontsource/ibm-plex-sans/700.css'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/500.css'
import '@fontsource-variable/plus-jakarta-sans'
import '@fontsource-variable/space-grotesk'
import '@fontsource-variable/jetbrains-mono'
import '@fontsource/atkinson-hyperlegible/400.css'
import '@fontsource/atkinson-hyperlegible/700.css'
import '@fontsource/atkinson-hyperlegible-mono/400.css'
import '@fontsource/atkinson-hyperlegible-mono/500.css'
import './index.css'
import App from './App.tsx'
import { SignInPage } from './components/SignInPage'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* VMS serves this page for sign-in and waiting for approval too (#286). */}
    {window.location.pathname.startsWith('/auth/')
      ? <SignInPage path={window.location.pathname} search={window.location.search} />
      : <App />}
  </StrictMode>,
)
